// Talks to /api/v1/user/settings. Caller must supply the API bearer + identity hints (same shape as chatClient).

export interface UserSettings {
  widgetScript: string;
  orgId: string;
  orgUrl: string;
  widgetId: string;
  updatedUtc: string;
}

interface AuthArgs {
  authBearer: string;
  homeAccountId: string;
  username: string;
}

function authHeaders(args: AuthArgs): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${args.authBearer}`,
    'X-CMSP-User-HomeAccountId': args.homeAccountId,
    'X-CMSP-User-Username': args.username,
  };
}

export async function getUserSettings(args: AuthArgs): Promise<UserSettings | null> {
  const res = await fetch('/api/v1/user/settings', { method: 'GET', headers: authHeaders(args) });
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`settings ${res.status}: ${await res.text()}`);
  return (await res.json()) as UserSettings;
}

export async function putUserSettings(
  args: AuthArgs & { widgetScript: string }
): Promise<UserSettings> {
  const res = await fetch('/api/v1/user/settings', {
    method: 'PUT',
    headers: authHeaders(args),
    body: JSON.stringify({ widgetScript: args.widgetScript }),
  });
  if (!res.ok) throw new Error(`settings ${res.status}: ${await res.text()}`);
  return (await res.json()) as UserSettings;
}

export async function deleteUserSettings(args: AuthArgs): Promise<void> {
  const res = await fetch('/api/v1/user/settings', { method: 'DELETE', headers: authHeaders(args) });
  if (!res.ok && res.status !== 204) {
    throw new Error(`settings ${res.status}: ${await res.text()}`);
  }
}
